<template>
  <div class="side-menu-left" >
    <div class="top-menu-logo">
      <RouterLink to="/" v-if="currentYear === 2024">
        <img class="d-logo businessLogo" src="/static/front/images/menu-images/b1g1-logo-cap.svg" alt="alt">
        <img class="d-logo personalLogo" src="/static/front/images/menu-images/b1g1-logo-2-cap.svg" alt="alt">
      </RouterLink>
      <RouterLink to="/" v-else>
        <img class="d-logo businessLogo" src="/static/front/images/menu-images/b1g1-logo.svg" alt="alt">
        <img class="d-logo personalLogo" src="/static/front/images/menu-images/b1g1-logo-2.svg" alt="alt">
      </RouterLink>
    </div>
    <div class="profile-wrapper" v-if="user.account === 'company'">
      <div class="notification-wrapper"><span>{{ companyName.charAt(0) }}</span>
        <div class="noti-wrapper">
          <div class="Company-Account">Company Account</div>
          <h4 class="user-neme">{{
            companyName.length > 25
                      ? companyName.substr(0, 25) + '...'
                      : companyName
                  }}</h4>
          <div class="Impacts-Created"><div>{{formattedTotalImpacts}}</div> Impacts Created</div>
        </div>
      </div>
    </div>
      <div class="profile-wrapper" v-if="user.account !== 'company'">
      <div class="notification-wrapper"><span>{{ user.first_name.charAt(0) }}</span>
        <div class="noti-wrapper">
          <div class="Company-Account">Personal Account</div>
          <h4 class="user-neme">{{
                    user.first_name.length > 25
                      ? user.first_name.substr(0, 25) + '...'
                      : user.first_name
                  }}</h4>
          <div class="Impacts-Created"><div>{{formattedTotalImpacts}}</div> Impacts Created</div>
        </div>
      </div>
    </div>
    <div class="menu-item">
        <template>
          <div>
            <nav class="navbar">
              <ul>
                <li :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/', '/impact',])}"><!--menu-list-active -->
                  <div class="menu-wrapper" @click="goToDashboard">
                    <div class="menu-icon">
                      <span
                          v-tooltip.left="{ content: 'Dashboard', class: 'normal-tooltip sidebar-menu-tooltip' }"
                          class="infopop" data-container="body" data-toggle="popover">
                        <img src="/static/front/images/menu-images/dashboard-icon.svg" alt="">
                      </span>
                    </div>
                    <RouterLink to="/" class="primery-menu-link" @click.native="closeMenu">Dashboard</RouterLink>
                  </div>
                </li>
                <li :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/view-all-projects', '/engagement-tool', '/recurring-impacts', '/create-recurring-impacts'])}">
                  <div class="menu-wrapper" @click="openIconDropDown">
                    <div class="menu-icon">
                      <span
                          v-tooltip.right="{ content: 'Create Impacts', class: 'normal-tooltip sidebar-menu-tooltip' }"
                          class="infopop" data-container="body" data-toggle="popover">
                        <img src="/static/front/images/menu-images/create-impact-icon.svg" alt="">
                      </span>
                    </div>
                    <RouterLink to="#" class="primery-menu-link active" @click.prevent="toggleDropdown">Create Impacts</RouterLink>
                    <div class="arrow-down" @click="toggleDropdown"><img src="/static/front/images/menu-images/arrow-icon.svg" alt=""></div>
                  </div>
                  <div class="submenu-list">
                    <ul>
                      <li><RouterLink to="/view-all-projects" v-if="!isDowngradeUser"  @click.native="closeMenu" >Explore Project List</RouterLink></li>
                      <li><RouterLink to="/view-all-projects" @click.native="closeMenu" v-if="isDowngradeUser" v-tooltip.top="{ content: 'Please upgrade your account to access embed codes. Contact us for help.', class: 'normal-tooltip' }">Explore Project List</RouterLink></li>
                      <li><RouterLink to="/recurring-impacts" @click.native="closeMenu" v-if="isDowngradeUser" v-tooltip.top="{ content: 'Please upgrade your account to access embed codes. Contact us for help.', class: 'normal-tooltip' }">Create Recurring Impacts</RouterLink></li>
                      <li><RouterLink to="/recurring-impacts" @click.native="closeMenu" v-if="!isDowngradeUser">Create Recurring Impacts</RouterLink></li>
                      <li class="hideFromPersonalMenu"><RouterLink to="/engagement-tool" @click.native="closeMenu">Enhanced Engagement Tool</RouterLink></li><!-- Hide from personal account menu -->
                    </ul>
                  </div>
                </li>
                <li :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/impact-history', '/giving-widget'])}" v-if="!isDowngradeUser">
                  <div class="menu-wrapper" @click="openIconDropDown">
                    <div class="menu-icon">
                      <span
                          v-tooltip.right="{ content: 'Track Your Impacts', class: 'normal-tooltip sidebar-menu-tooltip' }"
                          class="infopop" data-container="body" data-toggle="popover">
                        <img src="/static/front/images/menu-images/track-icon.svg" alt="">
                      </span>
                    </div>
                    <RouterLink to="#" class="primery-menu-link" @click.prevent="toggleDropdown">Track Your Impacts</RouterLink>
                    <div class="arrow-down" @click="toggleDropdown"><img src="/static/front/images/menu-images/arrow-icon.svg" alt=""></div>
                  </div>
                  <div class="submenu-list">
                    <ul>
                      <!-- <li v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)"><RouterLink to="/impact-history" @click.native="closeMenu">View Impact History</RouterLink></li> -->
                      <li><RouterLink to="/impact-history" @click.native="closeMenu">View Impact History</RouterLink></li>
                      <li class="d-sm-none hideFromPersonalMenu"><RouterLink to="/giving-widget" @click.native="closeMenu">Embed Impact Widgets</RouterLink></li>
                      <li><RouterLink to="/project-updates/list" @click.native="closeMenu">Follow Your Impact Updates</RouterLink></li>
                    </ul>
                  </div>
                </li>
                <li class="d-sm-none hideFromPersonalMenu" :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/token-management', '/team-accounts-management'])}" v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)"><!-- Hide from personal account menu -->
                  <div class="menu-wrapper" @click="openIconDropDown">
                  <div class="menu-icon">
                    <span
                      v-tooltip.right="{ content: 'Team & Tokens', class: 'normal-tooltip sidebar-menu-tooltip' }" class="infopop" data-container="body" data-toggle="popover">
                      <img src="/static/front/images/menu-images/engage-icon.svg" alt="">
                    </span>
                    </div>
                    <RouterLink to="#" class="primery-menu-link" @click.prevent="toggleDropdown">Team & Tokens</RouterLink>
                    <div class="arrow-down" @click="toggleDropdown"><img src="/static/front/images/menu-images/arrow-icon.svg" alt=""></div>
                  </div>
                  <div class="submenu-list">
                    <ul>
                      <li class="d-sm-none"><RouterLink to="/token-management" @click.native="closeMenu">Manage Impact Tokens</RouterLink></li>
                      <li><RouterLink to="/team-accounts-management" @click.native="closeMenu">Manage Team Accounts</RouterLink></li>
                    </ul>
                  </div>
                </li>
                <li class="hideFromPersonalMenu d-lg-none" :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/invite'])}">
                <!-- <li :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/', '/invite',])}"> -->
                  <div class="menu-wrapper">
                    <div class="menu-icon">
                      <span
                          v-tooltip.left="{ content: 'Refer Another Business', class: 'normal-tooltip sidebar-menu-tooltip' }"
                          class="infopop" data-container="body" data-toggle="popover">
                        <img src="/static/front/images/menu-images/dashboard-icon.svg" alt="">
                      </span>
                    </div>
                     <RouterLink :to="isHivePartner === 1 ? '/hive-builder' : '/invite'" class="primery-menu-link" @click.native="closeMenu">Refer Another Business</RouterLink>
                    <!-- <RouterLink :to="isHivePartner === 1 ? '/hive-builder' : '/invite'" class="primery-menu-link" @click.native="closeMenu"> Refer Another Business11</RouterLink> -->
                  </div>
                </li>

                <!-- <li class="d-lg-none hideFromPersonalMenu" :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/invite'])}">
                  <div class="menu-wrapper" @click="openIconDropDown">
                    <div class="menu-icon">
                      <span
                        v-tooltip.right="{ content: 'Refer Another Business', class: 'normal-tooltip sidebar-menu-tooltip' }" class="infopop" data-container="body" data-toggle="popover">
                        <img src="/static/front/images/menu-images/share-icon.svg" alt="">
                      </span>
                    </div>
                    <RouterLink :to="isHivePartner === 1 ? '/hive-builder' : '/invite'" class="primery-menu-link" @click.native="closeMenu"> Refer Another Business11</RouterLink>
                  </div>
                </li> -->
                <li class="d-sm-none hideFromPersonalMenu" :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/invite', '/gratitude-certificate', '/media-kit-brand-guideline'])}">
                  <div class="menu-wrapper" @click="openIconDropDown">
                  <div class="menu-icon">
                    <span
                      v-tooltip.right="{ content: 'Share & Inspire', class: 'normal-tooltip sidebar-menu-tooltip' }" class="infopop" data-container="body" data-toggle="popover">
                      <img src="/static/front/images/menu-images/share-icon.svg" alt="">
                    </span>
                    </div>
                    <RouterLink to="#" class="primery-menu-link" @click.prevent="toggleDropdown">Share & Inspire</RouterLink>
                    <div class="arrow-down" @click="toggleDropdown"><img src="/static/front/images/menu-images/arrow-icon.svg" alt=""></div>
                  </div>
                  <div class="submenu-list">
                    <ul>
                      <li><RouterLink :to="isHivePartner === 1 ? '/hive-builder' : '/invite'" @click.native="closeMenu">Refer Other Businesses</RouterLink></li>
                      <li><RouterLink to="/gratitude-certificate" @click.native="closeMenu">Create Gratitude Certificates</RouterLink></li>
                      <li><RouterLink to="/media-kit-brand-guideline" @click.native="closeMenu">Media Kit & Other Resources</RouterLink></li>
                    </ul>
                  </div>
                </li>
                <li :class="{'menu-list-wrapper': true, 'menu-list-active': isActiveRoute(['/business-listing','/impact-partnership', '/impact-partnership-b'])}">
                  <div class="menu-wrapper" @click="openIconDropDown">
                    <div class="menu-icon">
                      <span
                        v-tooltip.right="{ content: 'Community', class: 'normal-tooltip sidebar-menu-tooltip' }" class="infopop" data-container="body" data-toggle="popover">
                        <img src="/static/front/images/menu-images/community-icon.svg" alt="">
                      </span>
                    </div>
                    <RouterLink to="#" class="primery-menu-link" @click.prevent="toggleDropdown">Community</RouterLink>
                    <div class="arrow-down" @click="toggleDropdown"><img src="/static/front/images/menu-images/arrow-icon.svg" alt=""></div>
                  </div>
                  <div class="submenu-list">
                    <ul>
                      <li><RouterLink to="/events" @click.native="closeMenu">Event Calendar</RouterLink></li>
                      <li><RouterLink to="/business-listing" @click.native="closeMenu">Explore Business Listing</RouterLink></li>
                      <li class="hideFromPersonalMenu" v-if="partner_level === null"><RouterLink to="/impact-partnership" @click.native="closeMenu">My Partnership Status</RouterLink></li><!-- Hide from personal account menu -->
                      <li class="hideFromPersonalMenu" v-if="partner_level !== null"><RouterLink to="/impact-partnership-b" @click.native="closeMenu">My Partnership Status</RouterLink></li><!-- Hide from personal account menu -->
                      <!-- <li><a href="https://b1g1.com/events/overview" target="_blank">Attend Member Events</a></li> -->
                      <li><a href="https://blog.b1g1.com/" target="_blank">Explore Blog & Stories</a></li>
                      <!-- <li><RouterLink to="/events" @click.native="closeMenu">Event Calendar</RouterLink></li> -->
                    </ul>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </template>
    </div>
  </div>
</template>

<script>
import store from '../../store'
import { EventBus } from '../../eventBus'

export default {
  data () {
    return {
      currentYear: new Date().getFullYear(),
      isDowngradeUser: store.getters.currentUser ? store.getters.currentUser.role_id === 1 : false,
      totalImpacts: 0
    }
  },
  mounted () {
    EventBus.$on('total-impact-updated', (value) => {
      this.totalImpacts = value
    })
  },
  beforeDestroy () {
    EventBus.$off('total-impact-updated')
  },
  computed: {
    formattedTotalImpacts () {
      const num = this.totalImpacts
      if (!num || num === 0) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  methods: {
    // here is the code
    isActiveRoute (routes) {
      if (!Array.isArray(routes)) {
        return false
      }
      return routes.some(route => this.$route.path === route)
    },
    openIconDropDown (event) {
      // document.body.classList.toggle('left-menu-open')
      const currentMenuWrapper = event.currentTarget.closest('.menu-list-wrapper')
      const allMenuWrappers = document.querySelectorAll('.menu-list-wrapper')
      allMenuWrappers.forEach(wrapper => {
        if (wrapper !== currentMenuWrapper) {
          wrapper.classList.remove('menu-dropdown')
        }
      })
      currentMenuWrapper.classList.toggle('menu-dropdown')
      document.body.classList.add('left-menu-open')
    },
    toggleMenu () {
      document.body.classList.toggle('left-menu-open')
      this.closeAllDropdowns()
    },
    closeMenu () {
      document.body.classList.remove('left-menu-open')
      this.closeAllDropdowns()
    },
    goToDashboard () {
      this.$router.push('/')
    },
    toggleDropdown (event) {
      const currentMenuWrapper = event.currentTarget.closest('.menu-list-wrapper')
      const allMenuWrappers = document.querySelectorAll('.menu-list-wrapper')
      allMenuWrappers.forEach(wrapper => {
        if (wrapper !== currentMenuWrapper) {
          wrapper.classList.remove('menu-dropdown')
        }
      })
      currentMenuWrapper.classList.toggle('menu-dropdown')
    },
    closeAllDropdowns () {
      const menuWrappers = document.querySelectorAll('.menu-list-wrapper')
      menuWrappers.forEach(wrapper => {
        wrapper.classList.remove('menu-dropdown')
      })
    }
  },
  props: ['userRole', 'partner_level', 'user', 'isHivePartner', 'companyName']
}
</script>
<style>
  .left-menu-open .navbar ul li a {
    pointer-events: painted !important;
}
  </style>



// WEBPACK FOOTER //
// src/components/business/menu-custom.vue